import ManageCredits from './ManageCredits';
import { connect } from 'react-redux';

import {
  paymentsSel,
  pageNumberSel,
  pageSizeSel,
  totalElementsSel,
  totalPagesSel,
  isPendingSel,
  creditsActions,
  statusFilterSel
} from 'src/store/modules/credits';

const mapStateToProps = (state: any) => ({
  payments: paymentsSel(state),
  statusFilter: statusFilterSel(state),
  pageNumber: pageNumberSel(state),
  pageSize: pageSizeSel(state),
  totalElements: totalElementsSel(state),
  totalPages: totalPagesSel(state),
  isPending: isPendingSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  getCredits: (
    page: number,
    status: 'PENDING' | 'VOID' | 'DISPOSED',
    sortBy?: string
  ): any => {
    dispatch(creditsActions.getCredits(page, status, sortBy));
  }
});

export const pureComponent = ManageCredits;

export default connect(mapStateToProps, mapDispatchToProps)(ManageCredits);
